import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./config/userProvider";
import { SocketProvider } from "./config/socketContext";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.register("/sw.js")
//     .then(() => console.log("SW registered"))
//     .catch(err => console.log("SW registration failed", err));
// }

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.register("/sw.js")
//     .then(() => console.log("SW Registered"))
//     .catch(err => console.error("SW Registration Failed", err));
// }


// src/index.js or App.js
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js")
    .then(() => console.log("SW Registered"))
    .catch(console.error);
}





root.render(
  <React.StrictMode>
    <UserProvider>
      <SocketProvider>
        <BrowserRouter>
        <ToastContainer/>
          <App />
        </BrowserRouter>
      </SocketProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
